var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('UserList',{attrs:{"users":_vm.users,"loading":_vm.loading,"types":_vm.types}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }